import React from "react";

const RenewForm = ({ onSubmit, onCancel }) => {
	const amountRef = React.createRef();
	const dayRef = React.createRef();
	return (
		<form
			method="POST"
			onSubmit={event => {
				event.preventDefault();
				onSubmit({
					amount: parseInt(amountRef.current.value),
					days: parseInt(dayRef.current.value)
				});
				amountRef.current.value = "";
				dayRef.current.value = "";
			}}
		>
			<div className="form-group">
				<label htmlFor="amount">Amount Paid</label>
				<input
					type="number"
					className="form-control input-height"
					id="amount"
					min="0"
					required
					ref={amountRef}
					aria-describedby="amount"
					placeholder="Enter amount"
				/>
				<small id="amount" className="form-text text-muted">
					Amount Paid by the site/client
				</small>
			</div>

			<div className="form-group">
				<label htmlFor="days">How many days?</label>
				<input
					type="number"
					className="form-control input-height"
					id="days"
					min="28"
					required
					ref={dayRef}
					aria-describedby="days"
					placeholder="Enter days"
				/>
				<small id="days" className="form-text text-muted">
					How many days is the client paying for?
				</small>
			</div>
			<div className="text-center">
				<button
					type="button"
					onClick={onCancel}
					className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 margin-right-10 btn-circle btn-default"
				>
					<i className="material-icons text-danger">cancel</i> Cancel
				</button>

				<button
					type="submit"
					className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10  btn-circle btn-success"
				>
					Renew Subscription <i className="material-icons">arrow_right_alt</i>
				</button>
			</div>
		</form>
	);
};

export default RenewForm;
